var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgStatus = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 33.46h4.21c1.22 0 1.88-.3 2.31-1.55.96-2.81 1.96-5.6 2.94-8.4l1.5-4.29c.15-.44.68-2.58 1.42-1.58.2.26.2.97.27 1.28l.7 3.38c1.4 6.75 2.81 13.5 4.21 20.25.36 1.72.64 3.48 1.08 5.18.47 1.82 2.22 2.23 2.93.31.27-.74.49-1.51.74-2.26l3.58-10.72c.31-.93.29-1.55 1.37-1.6 1.57-.07 3.16 0 4.73 0 .86 0 .87-2.8 0-2.8h-4.21c-1.42 0-2.05.27-2.54 1.75-.91 2.74-1.83 5.47-2.74 8.2l-1.46 4.38c-.13.38-.56 2.39-1.33 1.35-.21-.29-.22-1.04-.29-1.38l-.72-3.46c-1.4-6.75-2.81-13.5-4.21-20.26-.35-1.66-.61-3.37-1.04-5.01-.48-1.84-2.2-2.16-2.91-.3-.28.74-.53 1.51-.79 2.26l-3.72 10.64c-.14.39-.24.85-.43 1.22-.25.5-.4.55-.91.6-1.53.15-3.15 0-4.7 0-.86 0-.87 2.8 0 2.8Z"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgStatus);
export default ForwardRef;